export const copertureAssicurative = [
  {
    tipo: "RC Professionale",
    priorita: "alta",
    importo: 3500,
    descrizione: "Copertura per errori e omissioni professionali nel settore IT",
    massimoStimato: "€1.000.000",
    creaPreventivo: true,
  },
  // ...
];

export const benchmarkSettore = {
  riskScore: 35,
  mediaSector: 55,
  fatturato: 1500000,
  mediaFatturato: 1300000,
  margineUtile: "12%",
  mediaUtile: "8%",
};

export const dettagliAzienda = {
  anagrafica: {
    sedeLegale: "Milano (Milano), Lombardia",
    formaGiuridica: "SRL",
    settore: "Software e Tecnologia",
    annoFondazione: "2018",
  },
  datiFinanziari: {
    fatturato: "€1.200.000",
    dipendenti: "25",
    capitaleSociale: "€50.000",
  },
};

export const fattoriRischio = {
  finanziario: 7,
  operativo: 6,
  settoriale: 5,
  dimensionale: 4,
  geografico: 8,
};